import { useState, useEffect } from 'react';
import './Centers.css';
import api from '../../../../api';

import DynamicBanner from '../../include/DynamicBanner';
import AboutSection from './Partials/AboutSection';
import French from './Partials/French';
import Scope from './Partials/Scope';
import OnlineCourse from './Partials/OnlineCourse';
import Curriculum from './Partials/Curriculum';
import Eligibility from './Partials/Eligibility';
import Contact from './Partials/Contact';

const Centers = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await api.get('/api/sitepages/about-us/center');
        setPageData(response.data.groups);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchPageData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!pageData) return null;

  const {
    banner_section,
    about_section,
    french_section,
    scope_section,
    online_course_section,
    curriculum_section,
    eligibility_section,
    contact_section
  } = pageData.reduce((acc, group) => ({ ...acc, ...group }), {});

  const desktopBannerImages =
  Array.isArray(banner_section?.images) && banner_section.images.length > 0
    ? banner_section.images
    : [];

const mobileBannerImages =
  Array.isArray(banner_section?.mobile_images) && banner_section.mobile_images.length > 0
    ? banner_section.mobile_images
    : [];

  return (
    <div className="centers-page">
     <DynamicBanner title={banner_section.title} bgImage={desktopBannerImages}  bgImageMobile={mobileBannerImages} />
    <AboutSection aboutSection={about_section} />
      <French frenchSection={french_section} />
      <Scope scopeSection={scope_section} />
      <OnlineCourse onlineCourseSection={online_course_section} />
      <Curriculum curriculumSection={curriculum_section} />
      <Eligibility eligibilitySection={eligibility_section} />
      <Contact contactSection={contact_section} />
    </div>
  );
};

export default Centers;
